import React from 'react';

interface ToggleButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  title: string;
}

/**
 * ToggleButton Component
 * 
 * Reusable toggle button with consistent styling for binary state controls.
 * Active state shows blue background, inactive shows gray.
 */
export const ToggleButton: React.FC<ToggleButtonProps> = ({
  label,
  isActive,
  onClick,
  title,
}) => {
  return (
    <button
      type="button"
      className={`px-3 py-1 text-sm rounded-md transition-colors flex items-center gap-2 ${
        isActive
          ? 'bg-blue-600 text-white hover:bg-blue-700'
          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
      }`}
      onClick={onClick}
      title={title}
      aria-pressed={isActive}
    >
      <span className="font-semibold">{label}</span>
    </button>
  );
};
